<template>
	<div class="home">
		<div class="layout" style="overflow: initial;">
			<Header />
			<div class="home">
				<!-- 顶部 Banner Swiper -->
				<div class="hbanner">
					<swiper class="banner-swiper" :loop="true" :autoplay="{ delay: 4000, disableOnInteraction: false }">
						<swiper-slide v-for="(item,index) in banner">
							<img :src="item.pic" alt="" />
							<div class="wrap">
								<div class="txt">
									<!-- <h3>{{item.title||''}}</h3>
									<p>{{item.desc||''}}</p>
									<a :href="item.url" class="hbtn">{{$t('nav.AboutUs')}}</a> -->
								</div>
							</div>
						</swiper-slide>
					</swiper>
					<div class="hspan"></div>
				</div>

				<div class="hsection1">
					<div class="wrap">
						<div class="htit">
							<h2>{{ $t('nav.ENTERPRISE') }}</h2>
						</div>
						<div class="flexul">
							<form @submit.prevent="searchEnterprise">
								<ul>
									<li>
										<el-select v-model="enterpriseSearch.type_id" clearable class="lsele txt"
											:placeholder="$t('nav.pleaseselect')">
											<el-option v-for="item in classList" :key="item.id" :label="item.cn_title"
												:value="item.id"></el-option>
										</el-select>
									</li>
									<li>
										<el-select v-model="enterpriseSearch.country_district" filterable clearable
											class="txt" :placeholder="$t('nav.CountryDistrict')" :filter-method="filterCountry">
											<el-option v-for="item in cityList" :key="item.value" :label="item.label"
												:value="item.value"></el-option>
										</el-select>
									</li>
									<li>
										<el-select v-model="enterpriseSearch.area_port" filterable clearable class="txt"
											:placeholder="$t('nav.CityServicePort')" :filter-method="filterPort">
											<el-option v-for="item in portList" :key="item.value" :label="item.label"
												:value="item.value"></el-option>
										</el-select>
									</li>
									<li>
										<el-select v-model="enterpriseSearch.company_name" filterable clearable
											class="txt" :placeholder="$t('nav.CompanyName')" allow-create :filter-method="filterCompany">
											<el-option v-for="item in restaurants4" :key="item.value"
												:label="item.label" :value="item.value"></el-option>
										</el-select>
									</li>
									<li>
										<el-select class="lsele txt" v-model="enterpriseSearch.service" filterable
											:placeholder="$t('nav.theproduct')" clearable style="width: 100%"
											allow-create :filter-method="filterService">
											<el-option v-for="item in restaurants3" :key="item.value"
												:label="item.label" :value="item.value">
											</el-option>
										</el-select>
									</li>
									<!-- 	<li>
										<input class="txt txt2" v-model="enterpriseSearch.company_name"
											:placeholder="$t('nav.companyname')" type="text" />
									</li>
									<li>
										<input class="txt txt2" v-model="enterpriseSearch.service"
											:placeholder="$t('nav.theproduct')" type="text" />
									</li> -->
									<li>
										<div class="sbtn" @click="searchEnterprise">
											<img src="../assets/images/qw6.png" alt="" />{{ $t('nav.SEARCH') }}
										</div>
									</li>
								</ul>
							</form>
						</div>

						<div class="qiyelist">
							<ul>
								<li v-for="item in enterpriseList" :key="item.id" :class="{'on':item.status==2}">
									<a href="javascript:;" @click="toPath('companyHome', item.id,{},item.status)">
										<div class="flex">
											<div class="ar"></div>
											<div class="ico">
												<img :src="item.logo  || require('../assets/images/qw8.png')" alt="" />
											</div>
										</div>
										<h4>{{ item.cn_name }}</h4>
										<h6>{{ item.en_name }}</h6>
									</a>
									<div class="text">
										<dl>
											<dd v-for="(keyword, idx) in item.en_Products" :key="idx"><a
													href="javascript:;">#{{ keyword.product_service }}</a></dd>
											<dd v-for="(keyword, idx) in item.ch_Products" :key="idx"><a
													href="javascript:;">#{{ keyword.product_service_cn }}</a></dd>
										</dl>
									</div>
								</li>
							</ul>

						</div>
						<div class="pages" v-if="enterpriseTotal > enterprisePageSize">
							<el-pagination background @current-change="handleEnterprisePageChange"
								:current-page="enterprisePage" :page-size="enterprisePageSize"
								layout="total, prev, pager, next" :total="enterpriseTotal">
							</el-pagination>
						</div>
					</div>
				</div>

				<div class="hsection2">
					<div class="wrap">
						<div class="htit">
							<h2>{{ $t('nav.ForumCommunity') }}</h2>
						</div>
						<div class="flexsp">
							<div class="hitemlist1">
								<ul>
									<li v-for="(item,index) in forumList" :key="item.id">
										<a href="javascript:;" @click="toPath('postDetail', item.id)">
											<h4>{{ item.title }}</h4>
											<div class="dzflex">
												<h6>
													<div class="ico">
														<img :src="item.userInfo?.headimg  || require('../assets/images/mrtx.png')"
															alt="" />
													</div>
													<p>{{ item.userInfo?.username || 'UNISO MARINE' }}</p>
												</h6>
												<div class="dz">{{ item.like_count || 0 }}</div>
												<div class="num">{{ item.comment_count || 0 }}</div>
											</div>
										</a>
									</li>
								</ul>
							</div>
							<div class="hitem2">
								<!-- 论坛轮播 swiper2 已修复 -->
								<div class="swiper2">
									<swiper ref="swiper2Ref" :allow-touch-move="false" :no-swiping="true">
										<swiper-slide>
											<a href="javascript:;"
												@click="toPath('postDetail', forumCarouselList[0]?.id)">
												<img :src="forumCarouselList[0]?.images?.[0] || require('../assets/images/qw20.jpg')"
													alt="" />
											</a>
										</swiper-slide>
									</swiper>
									<!-- <div class="prev"></div>
									<div class="next"></div> -->
								</div>


								<div class="text" v-if="featuredPost">
									<a href="javascript:;" @click="toPath('postDetail', featuredPost.id)">
										<h3 style="word-break:keep-all;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ featuredPost.title }}</h3>
										<p v-html="featuredPost.content"></p>
										<div class="dzflex">
											<h6>
												<div class="ico">
													<img :src="featuredPost.userInfo?.headimg || require('../assets/images/mrtx.png')"
														alt="" />
												</div>
												<p>{{ featuredPost.userInfo?.username || 'UNISO MARINE' }}</p>
											</h6>
											<div class="dz">{{ featuredPost.like_count || 0 }}</div>
											<div class="num">{{ featuredPost.comment_count || 0 }}</div>
										</div>
									</a>
								</div>
							</div>
							<div class="hitemlist1">
								<ul>
									<li v-for="(item,index) in forumList1" :key="item.id">
										<a href="javascript:;" @click="toPath('postDetail', item.id)">
											<h4>{{ item.title }}</h4>
											<div class="dzflex">
												<h6>
													<div class="ico">
														<img :src="item.userInfo?.headimg  || require('../assets/images/mrtx.png')"
															alt="" />
													</div>
													<p>{{ item.userInfo?.username || 'UNISO MARINE' }}</p>
												</h6>
												<div class="dz">{{ item.like_count || 0 }}</div>
												<div class="num">{{ item.comment_count || 0 }}</div>
											</div>
										</a>
									</li>
								</ul>
							</div>
							<!-- <div class="hitemhot">
								<h3 class="hctit"><i>{{ $t('nav.RecommendedCategories') }}</i></h3>
								<ul>
									<li v-for="(item, index) in hotKeywords" :key="item">
										<a href="javascript:;" @click="searchForumByKeyword(item)">
											<span></span>
											<h4>#{{ item }}</h4>
											<i v-if="index < 3">热</i>
										</a>
									</li>
								</ul>
							</div> -->
						</div>
						<div class="flexbtn">
							<a href="javascript:;" class="wbtn wbtn1"
								@click="refreshForum"><i></i>{{ $t('nav.Refresh') }}</a>
							<a href="javascript:;" class="wbtn active"
								@click="toPath('Forum')">{{ $t('nav.ViewMore') }}</a>
						</div>
					</div>
				</div>

				<div class="hsection3">
					<div class="wrap">
						<div class="htit">
							<h2>{{ $t('nav.DemandCommunity') }}</h2>
						</div>
						<div class="sheqlist">
							<ul>
								<li v-for="item in demandList" :key="item.id">
									<a href="javascript:;" @click="toPath('Netails', item.id)">
										<h4>{{ item.title }}</h4>
										<h6><i v-for="item2 in item.key_word"
												:class="'wi' + item.post_type">{{ item2 }}</i></h6>
										<div class="dzflex">
											<h6>
												<div class="ico">
													<img :src="item.userInfo?.headimg || require('../assets/images/mrtx.png')"
														alt="" />
												</div>
												{{ item.userInfo?.username || 'UNISO MARINE' }}
											</h6>
											<div class="dz">{{ item.like_count || 0 }}</div>
											<div class="num">{{ item.comment_count || 0 }}</div>
										</div>
									</a>
								</li>
							</ul>
						</div>
						<div class="flexbtn">
							<a href="javascript:;" class="wbtn wbtn1"
								@click="refreshDemand"><i></i>{{ $t('nav.Refresh') }}</a>
							<a href="javascript:;" class="wbtn active"
								@click="toPath('demand')">{{ $t('nav.ViewMore') }}</a>
						</div>
					</div>
				</div>

				<div class="hsection4">
					<div class="wrap">
						<div class="htit">
							<h2>{{ $t('nav.VideoBrowse') }}</h2>
						</div>
						<div class="videolist">
							<ul>
								<li v-for="(item,index) in videoList.slice(0, 7)" :key="item.id"
									:class="{ active: index === 1 }">
									<a href="javascript:;" @click="toPath('videodel', item.id)">
										<div class="pic">
											<img :src="item.cover_image" alt="" />
											<i>{{item.play_time }}</i>
										</div>
										<div class="text">
											<h4>{{ item.title }}</h4>
											<h5><i v-for="(kw, idx) in item.key_word" :key="idx">#{{ kw }}</i></h5>
											<div class="dzflex">
												<div class="yan">{{ item.play_count || 0 }}</div>
												<div class="num">{{ item.comment_count || 0 }}</div>
												<h6>
													<div class="ico">
														<img :src="item.userInfo?.headimg || require('../assets/images/mrtx.png')"
															alt="" />
													</div>
													<p>{{ item.userInfo?.username || 'UNISO MARINE' }}</p>
												</h6>
											</div>
										</div>
									</a>
								</li>
							</ul>
						</div>
						<div class="flexbtn">
							<a href="javascript:;" class="wbtn wbtn1"
								@click="refreshVideo"><i></i>{{ $t('nav.Refresh') }}</a>
							<a href="javascript:;" class="wbtn active"
								@click="toPath('video')">{{ $t('nav.ViewMore') }}</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer />
	</div>
</template>

<script setup>
	import {
		ref,
		onMounted,
		nextTick,
		watch
	} from 'vue'
	import {
		useRouter
	} from 'vue-router'
	import {
		ElMessage
	} from 'element-plus'
	import {
		get,
		post
	} from '@/api/api.js'
	import Header from '@/components/Header.vue'
	import Footer from '@/components/Footer.vue'

	import {
		useI18n
	} from 'vue-i18n'
	// ======== Swiper 核心导入（修复关键） ========
	import {
		Swiper,
		SwiperSlide
	} from 'swiper/vue'
	import {
		Autoplay,
		Navigation
	} from 'swiper/modules'
	import 'swiper/css'
	import 'swiper/css/navigation'
	import 'swiper/css/autoplay'

	const {
		t
	} = useI18n()
	const router = useRouter()
	const swiper2Ref = ref(null)

	// 企业搜索相关
	const enterpriseList = ref([])
	const enterprisePage = ref(1)
	const enterprisePageSize = ref(12)
	const enterpriseTotal = ref(0)
	const enterpriseSearch = ref({
		type_id: '',
		country_district: '',
		area_port: '',
		company_name: '',
		service: ''
	})

	// 分类列表
	const classList = ref([])
	// 城市列表
	const cityList = ref([])
	const allCityList = ref([])
	// 港口列表
	const portList = ref([])
	const allPortList = ref([])

	const restaurants3 = ref([])
	const allRestaurants3 = ref([])
	const restaurants4 = ref([])
	const allRestaurants4 = ref([])
	// 论坛相关
	const forumList = ref([])
	const forumList1 = ref([])
	const forumCarouselList = ref([])
	const featuredPost = ref(null)
	const hotKeywords = ref(['船舶技术问题问答帖', '船舶海工故障排除经验分享贴', '海事规则咨询帖', '船舶海工知识分享帖', '航行经验分享帖'])

	// 需求相关
	const demandList = ref([])

	// 视频相关
	const videoList = ref([])


	const page1 = ref(1)
	const page2 = ref(1)
	const page3 = ref(1)

	const banner = ref([]);

	// 监听企业分类变化，更新港口和产品/服务列表
	watch(() => enterpriseSearch.value.type_id, (newTypeId) => {
		getPortList(newTypeId)
	})

	const filterService = (query) => {
		if (!query) {
			restaurants3.value = [...allRestaurants3.value]
			return
		}
		const searchValue = query.toLowerCase()
		restaurants3.value = allRestaurants3.value.filter(item => {
			return item.label.toLowerCase().includes(searchValue) || item.value.toLowerCase().includes(searchValue)
		})
	}

	const filterCompany = (query) => {
		if (!query) {
			restaurants4.value = [...allRestaurants4.value]
			return
		}
		const searchValue = query.toLowerCase()
		restaurants4.value = allRestaurants4.value.filter(item => {
			return item.label.toLowerCase().includes(searchValue) || item.value.toLowerCase().includes(searchValue)
		})
	}

	const filterPort = (query) => {
		if (!query) {
			portList.value = [...allPortList.value]
			return
		}
		const searchValue = query.toLowerCase()
		portList.value = allPortList.value.filter(item => {
			return item.label.toLowerCase().includes(searchValue) || item.value.toLowerCase().includes(searchValue)
		})
	}

	const filterCountry = (query) => {
		if (!query) {
			cityList.value = [...allCityList.value]
			return
		}
		const searchValue = query.toLowerCase()
		cityList.value = allCityList.value.filter(item => {
			return item.label.toLowerCase().includes(searchValue) || item.value.toLowerCase().includes(searchValue)
		})
	}

	// 格式化视频时长
	const formatDuration = (seconds) => {
		if (!seconds) return '00:00'
		const mins = Math.floor(seconds / 60)
		const secs = seconds % 60
		return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
	}



	// 获取企业分类列表
	const getClassList = async () => {
		try {
			const response = await post('storeClass', {}, 'json')
			if (response.code == 200) {
				let locale = localStorage.getItem('locale');
				let data = response.data;
				if (locale == 'en') {
					for (let i = 0; i < data.length; i++) {
						data[i]['cn_title'] = data[i]['en_title'];
					}
				}
				classList.value = data
			}
		} catch (error) {
			console.error('获取分类失败:', error)
		}
	}

	// 获取城市列表
	const getCityList = async () => {
		try {
			const type_locale = localStorage.getItem('locale') == 'zh' ? 1 : 2
			const response = await post('cityList', {
				type: type_locale
			}, 'json')
			if (response.code == 200) {
				const cityData = response.data.map(item => ({
					label: item.countries,
					value: item.countries
				}))
				cityList.value = cityData
				allCityList.value = cityData
			}
		} catch (error) {
			console.error('获取城市列表失败:', error)
		}
	}

	// 获取港口列表
	const getPortList = async (type_id = '') => {
		try {
			const response = await post('cityPortList', { type_id }, 'json')
			if (response.code == 200) {
				const portInfo = response.data.portInfo || []
				const productInfo = response.data.productInfo || []
				const nameInfo = response.data.nameInfo || []
				const portData = portInfo.map(item => ({
					label: item,
					value: item
				}))
				portList.value = portData
				allPortList.value = portData


				const productData = productInfo.map(i => ({
					label: i,
					value: i
				}))
				restaurants3.value = productData
				allRestaurants3.value = productData

				const nameData = nameInfo.map(i => ({
					label: i,
					value: i
				}))
				restaurants4.value = nameData
				allRestaurants4.value = nameData
			}
		} catch (error) {
			console.error('获取港口列表失败:', error)
		}
	}

	// 搜索企业
	const searchEnterprise = async () => {
		enterprisePage.value = 1
		await getEnterpriseList()
	}

	// 获取企业列表
	const getEnterpriseList = async () => {
		try {
			const response = await post('storeList', {
				page: enterprisePage.value,
				limit: enterprisePageSize.value,
				type_id: enterpriseSearch.value.type_id,
				country_district: enterpriseSearch.value.country_district,
				area_port: enterpriseSearch.value.area_port,
				company_name: enterpriseSearch.value.company_name,
				product_service: enterpriseSearch.value.service
			}, 'json')
			if (response.code == 200) {
				enterpriseList.value = response.data.list || []
				enterpriseTotal.value = response.data.count || 0

			}
		} catch (error) {
			console.error('获取企业列表失败:', error)
		}
	}

	// 企业分页
	const handleEnterprisePageChange = (page) => {
		enterprisePage.value = page
		getEnterpriseList()
	}

	//获取轮播图
	const getBanner = async () => {
		try {
			const response = await post('getBanner', {}, 'json')
			if (response.code == 200) {
				let lang = localStorage.getItem('locale') || 'en';
				let bannerlist = [];
				if (lang == 'en') {
					for (let i = 0; i < response.data.length; i++) {
						if(response.data[i].type==1){
							bannerlist.push({
								title: response.data[i].title_en,
								desc: response.data[i].desc_en,
								url: response.data[i].url_en,
								pic: response.data[i].pic,
							})
						}
					}
					banner.value = bannerlist || []
				} else {
					for (let i = 0; i < response.data.length; i++) {
						if(response.data[i].type==2){
							bannerlist.push({
								title: response.data[i].title_en,
								desc: response.data[i].desc_en,
								url: response.data[i].url_en,
								pic: response.data[i].pic,
							})
						}
					}
					banner.value = bannerlist || []
				}
			}
		} catch (error) {
			console.error('获取轮播图失败:', error)
		}
	}

	// 获取论坛列表（首页）
	const getForumList = async () => {
		try {
			const response = await post('forumList', {
				page: page1.value,
				limit: 10,
				is_home: 1
			}, 'json')
			if (response.code == 200) {
				page1.value = page1.value + 1;
				const list = response.data.list || []

				if (list.length < 10) {
					page1.value = 1;
				}
				forumList.value = list.slice(0, 5).map(item => ({
					...item,
					key_word: item.key_word && typeof item.key_word === 'string' ? item.key_word.split(
						';') : []
				}))
				forumList1.value = list.slice(5, 10).map(item => ({
					...item,
					key_word: item.key_word && typeof item.key_word === 'string' ? item.key_word.split(
						';') : []
				}))
				forumCarouselList.value = list.slice(0, 3).map(item => ({
					...item,
					images: item.images && typeof item.images === 'string' ? item.images.split(';') : (
						item.images || []),
					key_word: item.key_word && typeof item.key_word === 'string' ? item.key_word.split(
						';') : []
				}))

				const featuredItem = list.find(item => item.images && item.images.length > 0) || list[0]
				if (featuredItem) {
					featuredPost.value = {
						...featuredItem,
						images: featuredItem.images && typeof featuredItem.images === 'string' ?
							featuredItem.images.split(';') : (featuredItem.images || []),
						key_word: featuredItem.key_word && typeof featuredItem.key_word === 'string' ?
							featuredItem.key_word.split(';') : []
					}
				}

				// 修复：数据加载完更新 swiper
				await nextTick()
				if (swiper2Ref.value?.$el) {
					swiper2Ref.value.swiper?.update()
				}
			}
		} catch (error) {
			console.error('获取论坛列表失败:', error)
		}

		// try {
		// 	const response = await post('forumList', {
		// 		page: page1.value+,
		// 		limit: 5,
		// 		is_home: 1
		// 	}, 'json')
		// 	if (response.code == 200) {
		// 		const list = response.data.list || []

		// 		forumList1.value = list.slice(0, 5).map(item => ({
		// 			...item,
		// 			key_word: item.key_word && typeof item.key_word === 'string' ? item.key_word.split(';') : []
		// 		}))
		// 		if (swiper2Ref.value?.$el) {
		// 			swiper2Ref.value.swiper?.update()
		// 		}
		// 	}
		// } catch (error) {
		// 	console.error('获取论坛列表失败:', error)
		// }
	}

	// 刷新论坛
	const refreshForum = () => {
		getForumList()
		ElMessage.success(t('nav.Refreshsuccessful'))
	}

	// 按关键词搜索论坛
	const searchForumByKeyword = (keyword) => {
		router.push({
			name: 'Forum',
			query: {
				search: keyword
			}
		})
	}

	// 获取需求列表（首页）
	const getDemandList = async () => {
		try {
			const response = await post('demandList', {
				page: page2.value,
				limit: 12,
				is_home: 1
			}, 'json')
			if (response.code == 200) {
				page2.value = page2.value + 1;
				const list = response.data.list || []
				if (list.length < 12) {
					page2.value = 1;
				}
				demandList.value = list.map(item => ({
					...item,
					// key_word: item.key_word && typeof item.key_word === 'string' ? item.key_word.split(';') : []
				}))
			}
		} catch (error) {
			console.error('获取需求列表失败:', error)
		}
	}

	// 刷新需求
	const refreshDemand = () => {
		getDemandList()
		ElMessage.success(t('nav.Refreshsuccessful'))
	}

	// 获取视频列表（首页）
	const getVideoList = async () => {
		try {
			const response = await post('VideoList', {
				page: page3.value,
				rows: 7,
				is_home: 1
			}, 'json')
			if (response.code == 200) {
				page3.value = page3.value + 1;
				const list = response.data.list || []
				if (list.length < 7) {
					page3.value = 1;
				}
				videoList.value = list.map(item => ({
					...item,
					// key_word: item.key_word && typeof item.key_word === 'string' ? item.key_word.split(';') : []
				}))
			}
		} catch (error) {
			console.error('获取视频列表失败:', error)
		}
	}

	// 刷新视频
	const refreshVideo = () => {
		getVideoList()
		ElMessage.success(t('nav.Refreshsuccessful'))
	}

	// 跳转页面
	const toPath = (name, id, query = {}, status = 1) => {

		if (status == 2) {
			ElMessage.error(t('nav.NotAvailable'))
			return false;
		}
		if (id) {
			router.push({
				name: name,
				query: {
					id: id,
					...query
				}
			})
		} else {
			router.push({
				name: name,
				query: query
			})
		}
	}

	// 初始化
	onMounted(() => {
		getClassList()
		getCityList()
		getPortList()
		getEnterpriseList()
		getForumList()
		getDemandList()
		getVideoList()
		getBanner();
	})
</script>

<style scoped>
	/* 你原有样式保留 */
	.el-select__wrapper {
		padding: 4px 4px !important;
	}
</style>